<template>
  <v-dialog
    v-model="dialogFlag"
    max-width="900"
  >
    <v-card v-if="selectedVideo && dialogFlag">
      <v-card-title>
        Video
      </v-card-title>
      <v-card-text>
        <div
          v-if="selectedVideo[server === 1 ? 'serverOne' : 'serverTwo']
            && Object.entries(selectedVideo[server === 1 ? 'serverOne' : 'serverTwo']).length"
          :key="`platformVideo${server}`"
        >
          <iframe
            v-if="selectedVideo[server === 1 ? 'serverOne' : 'serverTwo'].service === 'youtube'"
            class="videoPlayer"
            :src="`https://www.youtube.com/embed/${selectedVideo[server === 1 ? 'serverOne' : 'serverTwo'].id}`"
            :frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>

          <iframe
            v-else-if="selectedVideo[server === 1 ? 'serverOne' : 'serverTwo'].service === 'vimeo'"
            class="videoPlayer"
            :src="`https://player.vimeo.com/video/${selectedVideo[server === 1 ? 'serverOne' : 'serverTwo'].id}?color=ffffff&title=0&byline=0&portrait=0`"
            :frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>

          <div
            v-else
            class="videoPlayer"
          >
            Your browser does not support the video.
          </div>
        </div>

        <video
          v-else
          :key="`tagVideo${server}`"
          class="videoPlayer"
          :src="server === 1 ? selectedVideo.main_video_link : selectedVideo.fallback_video_link"
          autoplay
          controls
        >
          <source
            :src="server === 1
              ? selectedVideo.main_video_link : selectedVideo.fallback_video_link"
            type="video/avi"
          />
          <source
            :src="server === 1
              ? selectedVideo.main_video_link : selectedVideo.fallback_video_link"
            type="video/mp4"
          />
          <source
            :src="server === 1
              ? selectedVideo.main_video_link : selectedVideo.fallback_video_link"
            type="video/ogg"
          />
          Your browser does not support the video.
        </video>

        <div class="title">
          {{ selectedVideo.name }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          class="mr-2"
          :color="server === 1 ? 'primary' : ''"
          @click="server = 1"
        >
          Main
        </v-btn>
        <v-btn
          :color="server === 2 ? 'primary' : ''"
          @click="server = 2"
        >
          Fallback
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import videoInspector from '@/mixins/videoInspector';

export default {
  name: 'VideoPreview',

  mixins: [videoInspector],

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },

    selected: {
      type: Number,
      default: null,
    },

    videos: {
      type: Array,
      default: null,
    },
  },

  data: () => ({
    server: 1,
  }),

  computed: {
    dialogFlag: {
      get() {
        return this.dialog;
      },
      set(newValue) {
        this.$emit('update:dialog', newValue);
      },
    },

    selectedVideo() {
      let video = null;
      if (this.videos && this.videos.length && this.selected) {
        const filtered = this.videos.find((item) => this.selected === item.id);
        filtered.serverOne = this.getVideoInformation(
          filtered.main_video_link ? filtered.main_video_link : '',
        );
        filtered.serverTwo = this.getVideoInformation(
          filtered.fallback_video_link ? filtered.fallback_video_link : '',
        );

        video = filtered;
      }
      return video;
    },
  },

  watch: {
    selectedVideo(newValue) {
      if (newValue) {
        this.server = newValue.server;
      }
    },
  },
};
</script>

<style lang="scss">
  .videoPlayer {
    width: 100%;
    min-height: 400px;
  }
</style>
